const COMMON_SAFETY_TEMPLATE_KEY = "common-safety-template";
const COMMON_SAFETY_TEMPLATE_NAME = "共通安全雛形";

const COMMON_SAFETY_PROMPT_CONTENT = `---
key: common-safety-template
name: 共通安全雛形
version: 1
---
# 共通安全雛形（Tier①）

この雛形は人間レビュー済みの凍結テンプレであり、フローごとに自由生成しない。

## 必須制御
- 非常停止が成立していない間は、自動シーケンスを停止し、現在使用中の外部出力をすべて FALSE に戻す。
- 復電直後は \`Safety_PowerOnInitPending\` を使って初期化フックを一度だけ通し、初期化完了までは自動シーケンスへ入らない。
- 手動モード中、または自動許可が無い間は \`Step := 0\` に戻し、自動シーケンスを進めない。
- ウォッチドッグ用の \`Safety_WatchdogPulse\` を毎スキャン反転する。

## 実装ルール
- 変数名は \`Safety_EStopOk\`, \`Safety_AutoMode\`, \`Safety_ManualMode\`, \`Safety_PowerOnInitPending\`, \`Safety_WatchdogPulse\` をそのまま使う。
- 非常停止 / 復電初期化 / 手動モードの分岐は、通常の \`CASE Step OF ... END_CASE\` の外側に置く。
- 共通安全雛形を削除・改変せず、その内側に装置固有の安全処理を追加する。
`;

export function getCommonSafetyPromptSkill() {
    return {
        key: COMMON_SAFETY_TEMPLATE_KEY,
        name: COMMON_SAFETY_TEMPLATE_NAME,
        content: COMMON_SAFETY_PROMPT_CONTENT
    };
}

export function buildCommonSafetyDeclarationLines() {
    return [
        "Safety_EStopOk : BOOL := TRUE;",
        "Safety_AutoMode : BOOL := TRUE;",
        "Safety_ManualMode : BOOL := FALSE;",
        "Safety_PowerOnInitPending : BOOL := TRUE;",
        "Safety_WatchdogPulse : BOOL := FALSE;"
    ];
}

export function wrapBodyWithCommonSafetyTemplate(
    bodyLines,
    {
        stepVar = "Step",
        outputSignals = [],
        emergencyOutputAssignments = []
    } = {}
) {
    const safetyAssignments = Array.isArray(emergencyOutputAssignments) && emergencyOutputAssignments.length > 0
        ? emergencyOutputAssignments
        : outputSignals.map((signalName) => ({ signalName, stateValue: "FALSE" }));
    const lines = [
        "(* 共通安全雛形: 人間レビュー済みの凍結テンプレ *)",
        "Safety_WatchdogPulse := NOT Safety_WatchdogPulse;",
        "",
        "IF NOT Safety_EStopOk THEN",
        "    // 非常停止時は自動シーケンスを停止し、全出力を安全側へ倒す"
    ];

    for (const assignment of safetyAssignments) {
        lines.push(`    ${assignment.signalName} := ${assignment.stateValue};`);
    }

    lines.push(
        `    ${stepVar} := 0;`,
        "ELSIF Safety_PowerOnInitPending THEN",
        "    // 復電直後は1スキャンだけ初期化フックを通し、自動復帰を防ぐ"
    );

    for (const assignment of safetyAssignments) {
        lines.push(`    ${assignment.signalName} := ${assignment.stateValue};`);
    }

    lines.push(
        "    Safety_PowerOnInitPending := FALSE;",
        `    ${stepVar} := 0;`,
        "ELSIF Safety_ManualMode OR NOT Safety_AutoMode THEN",
        "    // 手動モード中は自動シーケンスを進めない",
        `    ${stepVar} := 0;`,
        "ELSE",
        ...bodyLines.map((line) => (line ? `    ${line}` : "")),
        "END_IF;"
    );

    return lines;
}
